export default "__VITE_ASSET__FaJ7LLc2__"